import { Panel } from 'primereact/panel'
import React, { useEffect } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import {
  Btn,
  BtnIcon,
  CustomCalendar,
  CustomCardColorBar,
  CustomDataTableHeader,
  CustomModal,
  CustomMultiSelect,
  NumeroDecimal,
  PageHeader,
  SectionTitle,
  TextBtn,
} from '../../../../components'
import {
  hideLoadingBox,
  showLoadingBox,
  showMessageBox,
} from '../../../../store/actions/system.actions'
import useResultadorPorEmpresa, { LOAD_MESSAGE } from './ResultadoPorEmpresaHook'
import * as colors from '../../../../assets/js/colors'
import CustomPieChart from '../../../../components/CustomPieChart/CustomPieChart'
import { DataTable } from 'primereact/datatable'
import { Column } from 'primereact/column'
import { FaRegFileExcel } from 'react-icons/fa'
import './ResultadoPorEmpresaStyle.css'

function ResultadoPorEmpresa({ dispatch, history, selectedTp }) {
  const { state, localDispatch } = useResultadorPorEmpresa()

  useEffect(() => {
    if (state.expandedRows) {
      const width =
        window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth

      let colSpan = 0

      if (width <= 768) {
        colSpan = 5
      } else if (width <= 1300) colSpan = 7
      else colSpan = 8

      const element = document.querySelector("td[colspan='11']")

      if (element) element.setAttribute('colspan', colSpan.toString())
    }
  }, [state.expandedRows])

  useEffect(() => {
    switch (state.loadingMessage) {
      case LOAD_MESSAGE.NONE:
        dispatch(hideLoadingBox())
        break

      case LOAD_MESSAGE.GET:
        dispatch(showLoadingBox('Aguarde...', state.loadingMessage))
        break

      default:
        break
    }
  }, [state.loadingMessage])

  useEffect(() => {
    localDispatch.onInit()
  }, [])

  useEffect(() => {
    if (state.errorMessage) {
      dispatch(showMessageBox(null, state.errorMessage))
      localDispatch.resetState()
    }
  }, [state.errorMessage])

  useEffect(() => {
    if (state.dataTableLazyLoading.first >= state.dataTableLazyLoading.totalRecords - 1) {
      localDispatch.getPageData(
        state.pInicial,
        state.pFinal,
        state.companySelected,
        selectedTp,
        state.dataTableLazyLoading.pageCount,
      )
    }
  }, [state.dataTableLazyLoading.first, state.dataTableLazyLoading.rows])

  return (
    <>
      <PageHeader>1.5 - Resultado por Empresa</PageHeader>
      <div style={{ marginTop: 16 }}>
        <Panel header={<TextBtn onClick={history.goBack}>Voltar</TextBtn>}>
          <div className="p-grid p-justify-center">
            <div className="p-grid p-col-12">
              <div className="p-col-12 p-lg-4">
                <CustomMultiSelect
                  label={'Empresa'}
                  options={state.companies}
                  onChange={localDispatch.onCompanyChange}
                  value={state.companySelected}
                  optionLabel={'name'}
                  filter={true}
                  marginTop={0}
                />
              </div>
              <div className="p-col-12 p-xl-4 p-grid">
                <div className="p-col-4">
                  <CustomCalendar
                    label="Período Inicial"
                    value={state.pInicial}
                    onChange={value => localDispatch.onChangePeriodoInicial(value)}
                  />
                </div>
                <div className="p-col-4">
                  <CustomCalendar
                    label="Período Final"
                    value={state.pFinal}
                    onChange={value => localDispatch.onChangePeriodoFinal(value)}
                  />
                </div>
                <div className="p-col-3">
                  <div style={{ marginLeft: 10, paddingTop: 27 }}>
                    <Btn
                      onClick={() =>
                        localDispatch.onBtnPesquisar(
                          state.pInicial,
                          state.pFinal,
                          state.companySelected,
                          selectedTp,
                        )
                      }
                    >
                      Pesquisar
                    </Btn>
                  </div>
                </div>
              </div>
            </div>
            <div className="p-grid p-col-12">
              <div className="p-col-12">
                <SectionTitle title={'Indicadores'} />
              </div>
              <div className="p-col-12 p-sm-6 p-lg-4 p-xl-3">
                <CustomCardColorBar
                  value={state.dashboardInfo.cardsInfo.qte_ciclos}
                  title={'Quantidade de Ciclos/Carga'}
                  subTitle={`em un`}
                  barColor={colors.azul}
                />
              </div>
              <div className="p-col-12 p-sm-6 p-lg-4 p-xl-3">
                <CustomCardColorBar
                  value={state.dashboardInfo.cardsInfo.qte_entregas}
                  title={'Qte de Entregas'}
                  subTitle={`em un`}
                  barColor={colors.azul_claro}
                />
              </div>
              <div className="p-col-12 p-sm-6 p-lg-4 p-xl-3">
                <CustomCardColorBar
                  value={state.dashboardInfo.cardsInfo.qte_caixas}
                  title={'Quantidade de caixas/volumes'}
                  subTitle={`em un`}
                  barColor={colors.azul_escuro}
                />
              </div>
              <div className="p-col-12 p-sm-6 p-lg-4 p-xl-3">
                <CustomCardColorBar
                  value={state.dashboardInfo.cardsInfo.peso}
                  title={'Peso'}
                  subTitle={`em KG`}
                  barColor={colors.azul_hover}
                />
              </div>
              <div className="p-col-12 p-sm-6 p-lg-4 p-xl-3">
                <CustomCardColorBar
                  value={state.dashboardInfo.cardsInfo.qte_faltas}
                  title={'Qte de Ocorrências de Faltas'}
                  subTitle={`em un`}
                  barColor={colors.laranja}
                />
              </div>
              <div className="p-col-12 p-sm-6 p-lg-4 p-xl-3">
                <CustomCardColorBar
                  value={state.dashboardInfo.cardsInfo.qte_sobras}
                  title={'Qte de Ocorrências de Sobras'}
                  subTitle={`em un`}
                  barColor={colors.itemHover}
                />
              </div>
              <div className="p-col-12 p-sm-6 p-lg-4 p-xl-3">
                <CustomCardColorBar
                  value={state.dashboardInfo.cardsInfo.indice_faltas_sobras}
                  title={'Índice de Ocorrencias'}
                  subTitle={`em porcentagem`}
                  barColor={colors.gray}
                />
              </div>
              <div className="p-col-12 p-sm-6 p-lg-4 p-xl-3">
                <CustomCardColorBar
                  value={state.dashboardInfo.cardsInfo.percent_devolucao_parcial}
                  title={'Devolução Parcial'}
                  subTitle={`em %`}
                  barColor={colors.error}
                />
              </div>
              <div className="p-col-12 p-sm-6 p-lg-4 p-xl-3">
                <CustomCardColorBar
                  value={state.dashboardInfo.cardsInfo.qte_entregas_conferidas}
                  title={'Qte de Entregas Conferidas'}
                  subTitle={`em un`}
                  barColor={colors.verde}
                />
              </div>
              <div className="p-col-12 p-sm-6 p-lg-4 p-xl-3">
                <CustomCardColorBar
                  value={state.dashboardInfo.cardsInfo.qte_entregas_nao_conferidas}
                  title={'Qte de Entregas Não Conferidas'}
                  subTitle={`em un`}
                  barColor={colors.vinho}
                />
              </div>
              <div className="p-col-12 p-sm-6 p-lg-4 p-xl-3">
                <CustomCardColorBar
                  value={state.dashboardInfo.cardsInfo.indice_conferidas_nao_conferidas}
                  title={'Índice de Conferências'}
                  subTitle={`em %`}
                  barColor={colors.violeta}
                />
              </div>
              <div className="p-col-12 p-sm-6 p-lg-4 p-xl-3">
                <CustomCardColorBar
                  value={state.dashboardInfo.cardsInfo.percent_devolucao_total}
                  title={'Devolução Total'}
                  subTitle={`em %`}
                  barColor={colors.pink}
                />
              </div>
              <div className="p-col-12 p-sm-6 p-lg-4 p-xl-3">
                <CustomCardColorBar
                  value={state.dashboardInfo.cardsInfo.qte_carros_enviado_rotas}
                  title={'Qte de Carros Enviados para Rota'}
                  subTitle={`em un`}
                  barColor={colors.azul_escuro}
                />
              </div>
              <div className="p-col-12 p-sm-6 p-lg-4 p-xl-3">
                <CustomCardColorBar
                  value={state.dashboardInfo.cardsInfo.qte_carros_retornados_rotas}
                  title={'Qte de Carros Retornados da Rota'}
                  subTitle={`em un`}
                  barColor={colors.azul}
                />
              </div>
              <div className="p-col-12 p-sm-6 p-lg-4 p-xl-3">
                <CustomCardColorBar
                  value={state.dashboardInfo.cardsInfo.valor_nfs}
                  title={'Valor das NFs'}
                  subTitle={`em R$`}
                  barColor={colors.azul_claro}
                />
              </div>
            </div>
            <div className="p-grid p-col-12">
              <div className="p-col-12">
                <SectionTitle title={'Gráficos'} />
              </div>
              <div className="p-col-12 p-lg-6">
                <CustomPieChart
                  title={'Qte de Caixas por TP'}
                  items={state.dashboardInfo.cardsInfo.qte_caixas_por_tp}
                  cellColors={state.colorsDefault}
                  borderTopColor={colors.azul}
                  height={200}
                />
              </div>
              <div className="p-col-12 p-lg-6">
                <CustomPieChart
                  title={'Tipos de Ocorrências'}
                  items={state.dashboardInfo.cardsInfo.tipos_ocorrencias}
                  cellColors={state.colorsDefault}
                  borderTopColor={colors.azul}
                  height={200}
                />
              </div>
              <div className="p-grid p-col-12">
                <div className="p-col-12">
                  <SectionTitle title={'Entrega x Status'} />
                </div>
                <div className="p-col-12">
                  <div
                    style={{
                      marginTop: 5,
                      pointerEvents: state.dashboardInfo.cardsInfo.entrega_status.length
                        ? 'all'
                        : 'none',
                    }}
                  >
                    <BtnIcon
                      onClick={() =>
                        localDispatch.onBtnExportClick(
                          state.dashboardInfo.cardsInfo.entrega_status.map(item => ({
                            status: item.name,
                            entregas: item.value,
                            porcentagem: (
                              (item.value / Number(state.dashboardInfo.cardsInfo.qte_entregas)) *
                              100
                            ).toFixed(2),
                          })),
                          'Entregas-Status',
                        )
                      }
                    >
                      <FaRegFileExcel size={18} color={colors.azul_escuro} />
                    </BtnIcon>
                  </div>
                  <div style={{ marginTop: 5 }}>
                    <DataTable
                      emptyMessage="Nenhuma Entrega x Status encontrada"
                      value={state.dashboardInfo.cardsInfo.entrega_status}
                      globalFilter={state.globalFilterStatus}
                      header={
                        <CustomDataTableHeader
                          onChange={value => localDispatch.OnGlobalFilterChange('status', value)}
                        />
                      }
                      paginator={true}
                      rows={10}
                      responsive
                    >
                      <Column field="name" header="Status" headerStyle={{ fontWeight: 300 }} />
                      <Column
                        field="value"
                        header="Entregas"
                        headerStyle={{ fontWeight: 300 }}
                        style={{ textAlign: 'center' }}
                      />
                      <Column
                        field="value"
                        header="Porcentagem"
                        headerStyle={{ fontWeight: 300 }}
                        body={data => (
                          <>
                            <NumeroDecimal>
                              {(data.value / Number(state.dashboardInfo.cardsInfo.qte_entregas)) *
                                100}
                            </NumeroDecimal>
                            {'%'}
                          </>
                        )}
                        style={{ textAlign: 'center' }}
                      />
                    </DataTable>
                  </div>
                </div>
              </div>
            </div>
            <div className="p-grid p-col-12">
              <div className="p-col-12">
                <SectionTitle title={'Listagem - Movimentação Entregas por Produto'} />
              </div>
              <div
                style={{
                  marginTop: 5,
                  pointerEvents: state.dashboardInfo.movimentacoes.length ? 'all' : 'none',
                }}
              >
                <BtnIcon
                  onClick={() =>
                    localDispatch.onBtnExportClick(
                      state.dashboardInfo.movimentacoes,
                      'Movimentacoes',
                      state.pInicial,
                      state.pFinal,
                      state.companySelected,
                      selectedTp,
                    )
                  }
                >
                  <FaRegFileExcel size={18} color={colors.azul_escuro} />
                </BtnIcon>
              </div>
              <div className="p-col-12">
                <DataTable
                  style={{
                    textAlign:
                      state.dataTableLazyLoading.movimentacoes.length > 0 ? 'inherit' : 'center',
                  }}
                  value={state.dataTableLazyLoading.movimentacoes}
                  loading={state.dataTableLazyLoading.loading}
                  paginator
                  rows={state.dataTableLazyLoading.rows}
                  totalRecords={state.dataTableLazyLoading.totalRecords}
                  lazy
                  first={state.dataTableLazyLoading.first}
                  onPage={e => localDispatch.onPage(e, state.dataTableLazyLoading.totalRecords)}
                  rowExpansionTemplate={data => rowExpansionTemplate(data)}
                  expandedRows={state.expandedRows}
                  onRowToggle={e => localDispatch.setExpandedRows(e.data)}
                  dataKey={'row_num'}
                  responsive
                >
                  <Column
                    className="btn-expandable"
                    expander={true}
                    field="more"
                    header="+"
                    style={{ width: 80 }}
                  />
                  <Column
                    className="column-text-overflow"
                    field="tp"
                    header="TP"
                    headerStyle={{ fontWeight: 300 }}
                  />
                  <Column
                    className="column-text-overflow"
                    field="identificador"
                    header="Identificador"
                    headerStyle={{ fontWeight: 300 }}
                  />
                  <Column
                    className="column-text-overflow"
                    field="cnpj_cliente"
                    header="CNPJ"
                    headerStyle={{ fontWeight: 300 }}
                  />
                  <Column
                    className="column-text-overflow"
                    field="nome_fantasia"
                    header="Nome "
                    headerStyle={{ fontWeight: 300 }}
                  />
                  <Column
                    className="column-responsive-md column-text-overflow"
                    field="num_nf"
                    header="Num. NF"
                    headerStyle={{ fontWeight: 300 }}
                  />
                  <Column
                    className="column-responsive-md column-text-overflow"
                    field="cidade"
                    header="Cidade"
                    headerStyle={{ fontWeight: 300 }}
                  />
                  <Column
                    className="column-responsive-xl"
                    field="uf"
                    header="Estado"
                    headerStyle={{ fontWeight: 300 }}
                  />
                  <Column
                    className="column-responsive-sm"
                    field="empresa"
                    header="Empresa"
                    headerStyle={{ fontWeight: 300 }}
                  />
                  <Column
                    className="column-responsive-sm"
                    field="cnpj_empresa"
                    header="CNPJ - Empresa"
                    headerStyle={{ fontWeight: 300 }}
                  />
                  <Column
                    className="btn-show-produtos"
                    field=""
                    body={data => (
                      <Btn onClick={() => localDispatch.showModalProdutos(true, data)}>
                        Ver Produtos
                      </Btn>
                    )}
                  />
                </DataTable>
              </div>
            </div>
            <div className="p-grid p-col-12">
              <div className="p-col-12">
                <SectionTitle title={'Listagem - Ocorrências'} />
              </div>
              <div className="p-col-12">
                <div
                  style={{
                    marginTop: 5,
                    pointerEvents: state.dashboardInfo.ocorrencias.length ? 'all' : 'none',
                  }}
                >
                  <BtnIcon
                    onClick={() =>
                      localDispatch.onBtnExportClick(
                        state.dashboardInfo.ocorrencias,
                        'Ocorrencias-Analíticas',
                      )
                    }
                  >
                    <FaRegFileExcel size={18} color={colors.azul_escuro} />
                  </BtnIcon>
                </div>
                <div style={{ marginTop: 5 }}>
                  <DataTable
                    emptyMessage="Nenhuma Ocorrência Apurada"
                    value={state.dashboardInfo.ocorrencias}
                    style={{
                      textAlign:
                        state.dashboardInfo.movimentacoes.length > 0 ? 'inherit' : 'center',
                    }}
                    globalFilter={state.globalFilterOco}
                    header={
                      <CustomDataTableHeader
                        onChange={value =>
                          localDispatch.OnGlobalFilterChange('occorrencias', value)
                        }
                      />
                    }
                    paginator={true}
                    rows={10}
                    responsive
                  >
                    <Column field="tp" header="Operador" headerStyle={{ fontWeight: 300 }} />
                    <Column
                      field="data_emissao"
                      header="Dt. Emissão"
                      headerStyle={{ fontWeight: 300 }}
                    />
                    <Column
                      field="ciclo"
                      header="Ciclo de Entrega"
                      headerStyle={{ fontWeight: 300 }}
                    />
                    <Column
                      field="identifier"
                      header="Identificador"
                      headerStyle={{ fontWeight: 300 }}
                    />
                    <Column
                      field="product_code"
                      header="Código"
                      headerStyle={{ fontWeight: 300 }}
                    />
                    <Column
                      field="product_name"
                      header="Produto"
                      headerStyle={{ fontWeight: 300 }}
                    />
                    <Column
                      field="ocorrencia"
                      header="Ocorrência"
                      headerStyle={{ fontWeight: 300 }}
                    />
                    <Column
                      field="quantidade"
                      header="Quantidade"
                      headerStyle={{ fontWeight: 300 }}
                      style={{ textAlign: 'center' }}
                    />
                    <Column field="stage" header="Etapa" headerStyle={{ fontWeight: 300 }} />
                  </DataTable>
                </div>
              </div>
            </div>
            <div className="p-grid p-col-12">
              <div className="p-col-12">
                <SectionTitle title={'Dados Expedição'} />
              </div>
              <div className="p-col-12">
                <div
                  style={{
                    marginTop: 5,
                    pointerEvents: state.dashboardInfo.cardsInfo.dadosExpedicao.length
                      ? 'all'
                      : 'none',
                  }}
                >
                  <Btn
                    className="mt-5 ml-2"
                    onClick={() =>
                      localDispatch.onBtnExportClick(
                        state.dashboardInfo.cardsInfo.dadosExpedicao,
                        'Dados-Expedicao',
                      )
                    }
                    disabled={!state.dashboardInfo.cardsInfo.dadosExpedicao.length}
                  >
                    Exportar
                  </Btn>
                </div>
              </div>
            </div>
          </div>
        </Panel>
      </div>
      <CustomModal
        header={'Produtos'}
        isVisible={state.showModalProdutos}
        maximizable={true}
        width={'100%'}
        onClose={() => localDispatch.showModalProdutos(false)}
      >
        <div className="p-col-12">
          <DataTable
            emptyMessage="Nenhum Produto"
            value={state.selectedRowProducts}
            paginator={true}
            rows={2}
            responsive
          >
            <Column field="product_code" header="Código" headerStyle={{ fontWeight: 300 }} />
            <Column field="descricao_produto" header="Produto" headerStyle={{ fontWeight: 300 }} />
            <Column field="qte_total" header="Qte. Total" headerStyle={{ fontWeight: 300 }} />
            <Column field="peso" header="Peso" headerStyle={{ fontWeight: 300 }} />
            <Column field="lote" header="Lote" headerStyle={{ fontWeight: 300 }} />
          </DataTable>
        </div>
      </CustomModal>
    </>
  )
}

const rowExpansionTemplate = data => {
  return (
    <div className="p-grid p-fluid" id={'expander' + data.row_num}>
      <div className="p-col-12 p-md-9">
        <div className="p-grid">
          <div className="p-md-2" style={{ fontWeight: 'bold' }}>
            Empresa:{' '}
          </div>
          <div className="p-md-4">{data.empresa}</div>
        </div>
        <div className="p-grid">
          <div className="p-md-2" style={{ fontWeight: 'bold' }}>
            CNPJ - Empresa:{' '}
          </div>
          <div className="p-md-4">{data.cnpj_empresa}</div>
        </div>
        <div className="p-col-12">
          <DataTable
            emptyMessage="Nenhum Produto"
            value={data.products}
            paginator={true}
            rows={10}
            responsive
          >
            <Column field="product_code" header="Código" headerStyle={{ fontWeight: 300 }} />
            <Column field="descricao_produto" header="Produto" headerStyle={{ fontWeight: 300 }} />
            <Column field="qte_total" header="Qte. Total" headerStyle={{ fontWeight: 300 }} />
            <Column field="peso" header="Peso" headerStyle={{ fontWeight: 300 }} />
            <Column field="lote" header="Lote" headerStyle={{ fontWeight: 300 }} />
          </DataTable>
        </div>
      </div>
    </div>
  )
}

const mapToProps = ({
  dashboard: {
    statusOperacoes: { status, pInicial, pFinal },
  },
  system: { selectedTp },
}) => ({ status, pInicial, pFinal, selectedTp })
export default connect(mapToProps)(withRouter(ResultadoPorEmpresa))
